// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-charge-dialog label[data-v-2a267e6c] {\n  font-size: 12px;\n  font-weight: normal;\n}\n.copy-charge-dialog .el-select[data-v-2a267e6c] {\n  width: 100%;\n}\n.copy-charge-dialog[data-v-2a267e6c] .el-form-item__label {\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
